// extracted by mini-css-extract-plugin
var _1 = "IntegrationMentionError-module__animatedBackground--ThrLu";
var _2 = "IntegrationMentionError-module__button--EXF83";
var _3 = "IntegrationMentionError-module__error--E1RBn";
var _4 = "IntegrationMentionError-module__icon--aVXCI";
var _5 = "IntegrationMentionError-module__title--u4yTs";
export { _1 as "animatedBackground", _2 as "button", _3 as "error", _4 as "icon", _5 as "title" }
